// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost ,APIGet} = require('utilities/APIRequestHelper');
const { formatText } = require('core/i18n').i18n;
// @ constants
const actionTypes = require('constants/actionTypes');
// @ helpers
const { downloadAsFile } = require('utilities/APIRequestHelper');

const getOnboardDocumentOkApiSuccess = (onboardDocumentOkApi) => ({
    type: actionTypes.GET_ONBOARD_DOCUMENT_OK_API_SUCCESS,
    payload: {
        onboardDocumentOkApi
    }
});

const getOnboardDocumentOkApiFailure = (error) => ({
    type: actionTypes.GET_ONBOARD_DOCUMENT_OK_API_ERROR,
    payload: {
        error
    }
});

const requestOnboardDocumentOkApiInProgress = () => ({
    type: actionTypes.GET_ONBOARD_DOCUMENT_OK_API_IN_PROGRESS,
});

const getOnboardDocumentDateSuccess = (response) => ({
    type: actionTypes.GET_ONBOARD_DOCUMENT_DATE_SUCCESS,
    payload: {
        date: response
    }
});

const getOnboardDocumentDateFailure = (error) => ({
    type: actionTypes.GET_ONBOARD_DOCUMENT_DATE_ERROR,
    payload: {
        error
    }
});

const requestOnboardDocumentDateInProgress = () => ({
    type: actionTypes.GET_ONBOARD_DOCUMENT_DATE_IN_PROGRESS,
});

const createPayloadOnboardDocumentDate = (value) => {
    return {
        query: {
            iban: value
        }
    };
}

const getContractDocumentOkApi =
    ( contract) => (dispatch) => {
        dispatch(requestOnboardDocumentOkApiInProgress());

        let requestData = {
            query: {
                documentType:"MI062"    ,contract
            },
        };

        return APIGet(
            dispatch,
            apiURLBuilder.getURL("apiDocumentsApplication"),
            requestData
        )
            .then((response) => {
                if (response && response.documents && response.documents[0]) {
                    dispatch(getOnboardDocumentOkApiSuccess(response.documents[0]));
                } else {
                    dispatch(getOnboardDocumentOkApiFailure());
                }
            })
            .catch((error) => {
                dispatch(getOnboardDocumentOkApiFailure(error));
            });
    };

const getOnboardDocumentDateExpService = (value) => (dispatch) => {
    dispatch(requestOnboardDocumentDateInProgress());
    return APIPost(
        dispatch,
        apiURLBuilder.getURL("getOnboardDocumentDate"),
        createPayloadOnboardDocumentDate(value)
    )
        .then((response) =>
            dispatch(getOnboardDocumentDateSuccess(response.date))
        )
        .catch((error) => {
            dispatch(getOnboardDocumentDateFailure(error));
            dispatch(getContractDocumentOkApi(value));
        });
};




const getOnboardDocumentDate = (iban, expediente = null) => (dispatch) => {
    expediente ? dispatch(getOnboardDocumentDateExpService(expediente)) : dispatch(getOnboardDocumentDateExpService(iban))
}

const getOnboardDocumentPdfSuccess = (response) => ({
    type: actionTypes.GET_ONBOARD_DOCUMENT_PDF_SUCCESS,
    payload: {
        response
    }
});

const getOnboardDocumentPdfFailure = (error) => ({
    type: actionTypes.GET_ONBOARD_DOCUMENT_PDF_ERROR,
    payload: {
        error
    }
});

const requestOnboardDocumentPdfInProgress = () => ({
    type: actionTypes.GET_ONBOARD_DOCUMENT_PDF_IN_PROGRESS,
});

const getOnboardDocumentPdf = (iban) => (dispatch) => {
    const requestData = {
        query: {
            iban: iban
        },
        header: {
            accept: 'application/pdf',
            responseType: 'arraybuffer'
        }
    };
    const fileName = formatText('profileContracts-fileName');
    dispatch(requestOnboardDocumentPdfInProgress());
    return APIPost(dispatch, apiURLBuilder.getURL('getOnboardDocumentPdf'), requestData)
        .then(response => {
            downloadAsFile(response.xhr.response, 'application/pdf', fileName + '.pdf');
            dispatch(getOnboardDocumentPdfSuccess(response));
        })
        .catch(error => dispatch(getOnboardDocumentPdfFailure(error)));
};

module.exports = {
    getOnboardDocumentDate,
    getOnboardDocumentPdf,
    getContractDocumentOkApi
};

